/**
 * Created by showzyl on 2017/3/3.
 */


;(function (win) {
	'use strict';

	// var mv_default_data = {
	// 	"banner": "../../img/roll/banner3.png",
	// 	"banner2": "../../img/roll/banner3.png",
	// 	// "banner2": "",
	// 	"video": "../../img/video/1280-720-15s.mp4",
	// 	"text": "<b>OUTSTANDING ORDINARY </b>: New line launched! New fun styles, and more BAGS",
	// 	"backgroud": "",
	// 	"cta_text": "Download",
	// 	"cta_url": "//cdn-adn.rayjump.com/cdn-adn/offersync/17/02/07/17/12/58998f7b688b2.jpg",
	// 	"share_facebook": 1,
	// 	"share_twitter": 1,
	// 	"share_instagram": 0,
	// 	"width": "320"
	// 	// "height": "50"
	// }

	var mv_default_data = {
		"banner": "https://hybird.rayjump.com/dsp/img/roll/banner3.png",
		"banner2": "https://hybird.rayjump.com/dsp/img/roll/banner3.png",
		// "banner2": "",
		"video": "https://hybird.rayjump.com/dsp/img/video/1280-720-15s.mp4",
		"text": "<b>OUTSTANDING ORDINARY </b>: New line launched! New fun styles, and more BAGS",
		"backgroud": "",
		"cta_text": "Download",
		"cta_url": "http://www.mobvista.com/",
		"share_facebook": 1,
		"share_twitter": 1,
		"share_instagram": 0,
		"width": "320",
		// "height": "50"
	}
	
	var defaultClick = 'click';

	document.addEventListener('DOMContentLoaded', function (event) {
		var data = _.extend(mv_default_data, mv_data);
		//反转义
		data.text = mv_util.unescapeHTML(data.text);
		handleRender(data);
	});

	function handleRender(data) {
		var banner = mv_util.getEl('#mv_banner');
		var mv_video_container = mv_util.getEl('#mv_video_container');

		mv_util.addClass(mv_util.getEl('#mv_page_init'), 'mv_none');
		mv_util.addClass(mv_util.getEl('.mv_mask')[0], 'mv_none');

		mvRender(data);
		bindEvent(data);

		if(data && mv_common.getTplSize(data)){
			// only render banner
			mv_util.createEl('img', banner, {
				src: data.banner
			});
			banner.addEventListener(defaultClick, function () {
				mv_stats({
					category: 'Richmedia',
					action: 'click_roll_banner',
					label: data.width + '_' + data.height
				});
				try {
					mraid.expand();
				} catch (e) {

				}
				mv_util.rmClass(mv_video_container, 'mv_none');
				mv_util.addClass(banner, 'mv_none');
				// 加背景
				if(data.backgroud){
					mv_util.getEl('body')[0].style.backgroundImage = 'url(' + data.backgroud + ')';
				}

				setTimeout(function(){
					//点击播放ga统计
					var mv_video_box = mv_util.getEl('.mv_video_box')[0];
					var action = mv_video_box.getAttribute('data-action');
					if(action){
						mv_stats({
							category: 'Richmedia',
							action: action,
							label: data.width + '_' + data.height
						});
					}
					mv_video_box.click();
				},100);

			})
		}else{
			mv_util.rmClass(mv_video_container, 'mv_none');
			setTimeout(function(){
				//点击播放ga统计
				var mv_video_box = mv_util.getEl('.mv_video_box')[0];
				var action = mv_video_box.getAttribute('data-action');
				if(action){
					mv_stats({
						category: 'Richmedia',
						action: action,
						label: data.width + '_' + data.height
					});
				}
				mv_video_box.click();
			},100);
		}

		// 统计
		var stats = mv_util.getEl('.mv_stats');
		mv_common.stats(stats);
		
	}

	function bindEvent(data) {
		var i;
		var mv_video_container = mv_util.getEl('#mv_video_container');
		var mv_video_box = mv_util.getEl('.mv_video_box')[0];
		var mv_video = mv_util.getEl('#mv_video');
		var mv_close_btn = mv_util.getEl('#mv_close_btn');
		var mv_banner = mv_util.getEl('#mv_banner');
		var mv_play_icon = mv_util.getEl('.mv_play_icon')[0];

		mv_video_box.addEventListener(defaultClick, function () {
			var url = mv_video.getAttribute('src');
			try {
				mraid.playVideo(url);
			}catch (e){
				//暂停or播放
				if(mv_video.paused){
					// 使用h5播放
					mv_video.play();
					// 隐藏 icon
					mv_util.addClass(mv_play_icon, 'mv_none');
					// ended
					mv_video.addEventListener('ended', function () {
						// 显示 icon
						mv_util.rmClass(mv_play_icon, 'mv_none');
					});
				}else{
					mv_video.pause();
					mv_util.rmClass(mv_play_icon, 'mv_none');
				}
			}
		}, false);

		var click_url = mv_util.getEl('.click_url');
		for(i=0;i<click_url.length;i++){
			click_url[i].addEventListener(defaultClick, function () {
				var url = this.getAttribute('data-url');
				var action = this.getAttribute('data-action');
				if(action){
					mv_stats({
						category: 'Richmedia',
						action: action,
						label: data.width + '_' + data.height
					});
				}
				try {
					mraid.open(url);
				}catch (e){
					window.open(url);
				}
			});
		}

		var notice_url = mv_util.getEl('.notice_url');
		for(i=0;i<click_url.length;i++){
			click_url[i].addEventListener(defaultClick, function () {
				var notice = this.getAttribute('data-notice');
				mv_util.createEl('script', '', {
					src: notice
				});
			});
		}

		mv_close_btn.addEventListener(defaultClick, function () {
			mv_util.addClass(mv_video_container, 'mv_none');
			mv_util.rmClass(mv_banner, 'mv_none');
			mv_video.pause();
			mv_util.getEl('body')[0].style.backgroundImage = '';
		});

		try {
			mraid.addEventListener("stateChange", function (state) {
				if (state === 'expanded') {
					mv_util.addClass(mv_banner, 'mv_none');
				} else {
					mv_util.rmClass(mv_banner, 'mv_none');
					mv_util.addClass(mv_video_container, 'mv_none');
					mv_video.pause();
					mv_util.getEl('body')[0].style.backgroundImage = '';
				}
			});
		} catch (e) {

		}

		mv_common.share(data);
	}
	
	function mvRender(data) {
		var mv_video_container = mv_util.getEl('#mv_video_container');
		var tpl = mv_util.getEl('#mv_tpl').innerHTML;
		if (data) {
			var sHtml = _.template(tpl)(data);
			mv_video_container.innerHTML = sHtml;
			var device = mv_util.device();
			var mv_appstore = mv_util.getEl('.mv_appstore')[0];
			var mv_googleplay = mv_util.getEl('.mv_googleplay')[0];
			if(device.isiOS){
				setTimeout(function () {
					mv_appstore && mv_util.rmClass(mv_appstore, 'mv_none');
				}, 5)
			}

			if(device.isAndroid){
				setTimeout(function () {
					mv_googleplay && mv_util.rmClass(mv_googleplay, 'mv_none');
				}, 5)
			}

			if(/rayjump/ig.test(location.href)){
				try {
					mv_appstore && mv_util.rmClass(mv_appstore, 'mv_none');
					mv_googleplay && mv_util.rmClass(mv_googleplay, 'mv_none');
				}catch (e){

				}
			}
		}
	}

	function mv_stats(cfg) {
		mv_common.gpStats(function () {
			var mv_ga = mv_util.getEl('#mv_ga');
			var param = mv_ga.getAttribute('data-param');
			param = JSON.parse(param);

			ga('set', {
				dimension1: param['offer'],
				dimension2: param['app'],
				dimension3: param['advertiser']
			});

			ga('send', {
				title: document.title,
				hitType: 'event',
				eventCategory: cfg.category, // 'Richmedia'
				eventAction: cfg.action, // 'Click_Roll_Banner'
				eventLabel: cfg.label // mv_data.width + mv_data.height
			});
		});
	}

	//调启ga统计
	mv_common.gpStats();

})(window);










